import React from "react";
import CaseStudyTemplatePage from "components/CaseStudyTemplate/CaseStudyTemplate";

import { useTranslation } from "react-i18next";

import imgBanner from "assets/images/pages/medulla-banner.jpg";
import imgIdeas2 from "assets/images/pages/medulla/medulla-ideas2.jpg";
import imgIdeas1 from "assets/images/pages/medulla/medulla-ideas1.jpg";
import imgResult1 from "assets/images/pages/medulla/medulla-result1.jpg";
import imgResult2 from "assets/images/pages/medulla/medulla-result2.jpg";
import imgResult3 from "assets/images/pages/medulla/medulla-result3.jpg";
import { PAGES } from "constants/pages";

const CaseStudyMedullaPage = () => {
  const { t } = useTranslation();
  document.title = t(PAGES.CASE_STUDY_BI_HEALTHCARE_SOLUTION.title);

  const data = {
    banner: {
      header: "caseStudies.medulla.banner.header",
      text: "caseStudies.medulla.banner.text",
      badges: t("caseStudies.medulla.banner.badges", {
        returnObjects: true,
      }),
      image: imgBanner,
      imageHeight: 618,
    },
    stats: t("caseStudies.medulla.stats", { returnObjects: true }),
    description: {
      header: "caseStudies.medulla.description.header",
      pargarafs: [
        {
          image: imgIdeas1,
          text: "caseStudies.medulla.description.paragrafs.paragraf1",
        },
        {
          image: imgIdeas2,
          text: "caseStudies.medulla.description.paragrafs.paragraf2",
        },
      ],
    },
    businessChallenges: t("caseStudies.medulla.businessChallenges", {
      returnObjects: true,
    }),
    ourSolutions: t("caseStudies.medulla.ourSolutions", {
      returnObjects: true,
    }),
    theResults: {
      header: "caseStudies.medulla.theResults.header",
      content: [
        {
          header: t("caseStudies.medulla.theResults.results.result1.text"),
          image: imgResult1,
          bgColor: "white",
        },
        {
          header: t("caseStudies.medulla.theResults.results.result2.text"),
          image: imgResult2,
          bgColor: "softBlue",
        },
        {
          header: t("caseStudies.medulla.theResults.results.result3.text"),
          image: imgResult3,
          bgColor: "thertiary",
        },
      ],
    },
    moreStories: {
      title: t("caseStudies.medulla.moreStories.header"),
      stories: t("caseStudies.medulla.moreStories.stories", {
        returnObjects: true,
      }),
    },
  };
  return <CaseStudyTemplatePage data={data} />;
};

export default CaseStudyMedullaPage;
